/**
 * Browser environment detector for corruption reports.
 *
 * Implements IEnvironmentDetector for browser environments.
 * Detects browser, OS, app version, online status, and timezone.
 */

import { Service } from '@toeverything/infra';

import type { ClientEnvironment, IEnvironmentDetector } from './interfaces';

export class BrowserEnvironmentDetector
  extends Service
  implements IEnvironmentDetector
{
  detect(): ClientEnvironment {
    const ua = navigator.userAgent;

    return {
      browser: this.detectBrowser(ua),
      os: this.detectOS(ua),
      appVersion: BUILD_CONFIG.appVersion ?? 'unknown',
    };
  }

  isOnline(): boolean {
    return navigator.onLine;
  }

  getTimezone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  private detectBrowser(ua: string): string {
    if (ua.includes('Firefox')) return 'Firefox';
    if (ua.includes('Edg/')) return 'Edge';
    if (ua.includes('Chrome')) return 'Chrome';
    if (ua.includes('Safari')) return 'Safari';
    return 'Unknown';
  }

  private detectOS(ua: string): string {
    if (ua.includes('Windows')) return 'Windows';
    if (ua.includes('Mac')) return 'macOS';
    if (ua.includes('Linux')) return 'Linux';
    if (ua.includes('Android')) return 'Android';
    if (ua.includes('iOS') || ua.includes('iPhone') || ua.includes('iPad'))
      return 'iOS';
    return 'Unknown';
  }
}
